import { useContext } from 'use-context-selector';
import { IncreasinglyBundleSection } from '../increasinglySection/IncreasinglyBundleSection';
import { ProductContext } from '../productContext/ProductProvider';

export const ProductIncreasinglySection = () => {
  const productContext = useContext(ProductContext);
  if (productContext === undefined)
    throw new Error(
      'Product IncreasinglySection must be used inside a ProductContext'
    );

  const { selectedVariant } = productContext;

  const sku = selectedVariant?.sku ?? '';

  // Needs to be the Shopify variant SKU
  const variantSKUs = [sku];

  return <IncreasinglyBundleSection productIds={variantSKUs} />;
};
